import { fromJS } from 'immutable';
import * as constants from './constants';
import R from 'ramda';

const initialNewPost = {
  selectedLocations: [],
  corporateLocSelected: false,
  postMessage: '',
  selectedFiles: [],
  selectedMainCategory: 'Updates',
  selectedSubCategory: '',
  subCategoryHash: '',
  selectedHashtags: [],
  showNewPostDialog: false,
  savingPost: false,
  uploadingFile: false,
};

const initialState = fromJS({
  MMFiles: [], // existing MM filtered for no powerpoints
  ownerMetaData: {
    // gotMetaData
    // followersCount
    // followsCount
    // postsCount
  },
  newsfeed: [],
  selectedLeftNav: 'News Feed',
  showNewPostDialog: false,
  hasMore: true,
  lastPostId: '',
  filter: {},
  filterType: '',
  // loaders
  savingPost: false,
  loadingNF: false,
  loadingHashtags: false,
  loadingMMFiles: false,
  deletingPost: false,
  reportingPost: false,
  updatingComment: false,
  updatingPost: false,

  hashtags: [],
  postComment: {
    comment: '',
    postId: '',
    lastCommentId: '',
    hasMoreComments: true,
    loading: false,
  },
  // for new post creation
  ...initialNewPost,

  // image preview
  viewingFile: {},
  viewingFiles: [],
});

export default function newsfeed(state = initialState, { type, payload }) {
  switch (type) {
    case constants.UPDATE_NEWSFEED_PROP:
      return state.merge(fromJS(payload));
    case constants.GET_NEWSFEED_STARTED:
      return state.set('loadingNF', true);
    case constants.GOT_INITIAL_LOAD_NEWSFEED:
      return state.set('newsfeed', fromJS(payload.list))
                  .set('loadingNF', false)
                  .set('lastPostId', payload.lastPostId)
                  .set('hasMore', !R.isEmpty(payload.list));
    case constants.LOADED_MORE_NEWSFEED:
      return state.update('newsfeed', list => {
        const listToJS = list.toJS();
        return fromJS(R.call(R.compose(
          R.reverse,
          R.sortBy(R.prop('timestamp')),
          R.uniqBy(R.prop('postId')),
          R.concat(listToJS),
          R.reject(R.propEq('postId', listToJS))
        ), payload.list));
      })
                  .set('loadingNF', false)
                  .set('lastPostId', payload.lastPostId)
                  .set('hasMore', !R.isEmpty(payload.list));
    case constants.GET_NEWSFEED_FAILED:
      return state.set('loadingNF', false);
    case constants.GET_SINGLE_POST_STARTING:
      return state.update('newsfeed', list => {
        if (!list) return list;
        return list.map(post => {
          if (post.get('postId') === payload.postId) return post.set('loading', true);
          return post;
        });
      });
    case constants.GOT_SINGLE_POST:
      return state.update('newsfeed', list => {
        if (!list) return list;
        return list.map(post => {
          if (post.get('postId') === payload.postId) return post.set('body', fromJS(payload.body)).set('loaded', true).set('loading', false);
          return post;
        });
      });
    case constants.GET_SINGLE_POST_FAILED:
      return state.update('newsfeed', list => {
        if (!list) return list;
        return list.filter(post => post.get('postId') !== payload.postId);
      });
    case constants.GET_HASHTAGS_STARTED:
      return state.set('loadingHashtags', true);
    case constants.GOT_HASHTAGS:
      return state.set('loadingHashtags', false)
                  .set('hashtags', fromJS(payload));
    case constants.GET_HASHTAGS_FAILED:
      return state.set('loadingHashtags', false);
    case constants.SUBMIT_POST_FAILED:
      return state.set('savingPost', false);
    case constants.SUBMIT_POST:
      return state.set('savingPost', true);
    case constants.POST_SUBMITTED:
      if (payload.isSingleLoc) {
        return state.update('newsfeed', list => list.unshift(fromJS({ postId: payload.postId, loaded: false, timestamp: new Date() })))
                    .merge(R.omit(['selectedLocations', 'corporateLocSelected'], initialNewPost));
      }
      return state.update('newsfeed', list => list.unshift(fromJS({ postId: payload.postId, loaded: false, timestamp: new Date() })))
                  .merge(initialNewPost);
    // load MM for newsfeed
    case 'GETTING_MARKETING_MATERIALS':
      return state.set('loadingMMFiles', true);
    case 'GOT_MARKETING_MATERIALS':
      return state.set('MMFiles', fromJS(R.propOr([], 'media', payload).filter(file => file.mediaType !== 'application/vnd.ms-powerpoint' && file.mediaType !== 'application/vnd.openxmlformats-officedocument.presentationml.presentation')))
                  .set('loadingMMFiles', false);
    // when a user adds / updates MM, get update for newsfeed
    case 'UPDATE_MM_PROP':
      if (!payload.savingMedia && R.contains('media', R.keys(payload))) {
        return state.set('MMFiles', fromJS(R.propOr([], 'media', payload).filter(file => file.mediaType !== 'application/vnd.ms-powerpoint' && file.mediaType !== 'application/vnd.openxmlformats-officedocument.presentationml.presentation')));
      }
      return state;
    case constants.DELETE_POST_STARTED:
      return state.set('deletingPost', true);
    case constants.DELETED_POST:
      return state.set('deletingPost', false)
                  .set('newsfeed', fromJS(payload));
    case constants.REPORT_POST_STARTED:
      return state.set('reportingPost', true);
    case constants.REPORTED_POST:
      return state.set('reportingPost', false)
                  .update('newsfeed', list => {
                    if (!list) return list;
                    return list.map(post => {
                      if (post.get('postId') === payload.postId) return post.update('body', body => body.merge(fromJS({ reported: true })));
                      return post;
                    });
                  });
    case constants.REPORT_POST_FAILED:
      return state.set('reportingPost', false);
    case constants.START_UPDATING_A_POST:
      if (payload.updateType === 'like' || payload.updateType === 'unlike') {
        return state.update('newsfeed', list => {
                      if (!list) return list;
                      return list.map(post => {
                        if (post.get('postId') === payload.postId) return post.update('body', body => body.merge(fromJS(payload.updater)));
                        return post;
                      });
                    });
      }
      if (payload.updateType === 'comment') {
        return state.update('newsfeed', list => {
                    if (!list) return list;
                    return list.map(post => {
                      if (post.get('postId') === payload.postId) {
                        return post.updateIn(['body', 'comments'], comments => comments.push(fromJS(R.merge(payload.updater.comment, { temporaryUuid: payload.temporaryUuid }))))
                                   .setIn(['body', 'numOfComments'], R.inc(post.getIn(['body', 'numOfComments'])));
                      }
                      return post;
                    });
                  });
      }
      if (payload.updateType === 'deleteComment') {
        return state.update('newsfeed', list => {
                      if (!list) return list;
                      return list.map(post => {
                        if (post.get('postId') === payload.postId) {
                          return post.updateIn(['body', 'comments'], comments => comments.filter(comment => comment.get('_id') !== R.path(['updater', 'commentId'], payload)))
                                     .setIn(['body', 'numOfComments'], R.dec(post.getIn(['body', 'numOfComments'])));
                        }
                        return post;
                      });
                    });
      }
      return state;
    case constants.UPDATED_POST:
      if (payload.updateType === 'comment') {
        return state.update('newsfeed', list => {
          if (!list) return list;
          return list.map(post => {
            if (post.get('postId') === payload.postId) {
              return post.updateIn(['body', 'comments'], comments => {
                return comments.map(comment => {
                  if (comment.get('temporaryUuid') === payload.temporaryUuid) return comment.set('_id', payload.response._id);
                  return comment;
                });
              });
            }
            return post;
          });
        });
      }
      return state;
    case (constants.REPORT_COMMENT_STARTED || constants.DELETE_COMMENT_STARTED):
      return state.set('updatingComment', true);
    case constants.REPORTED_COMMENT:
      return state.set('updatingComment', false)
                  .update('newsfeed', list => {
                    if (!list) return list;
                    return list.map(post => {
                      if (post.get('postId') === payload.postId) {
                        return post.updateIn(['body', 'comments'], comment => {
                          if (comment.get('_id') === payload.commentId) return comment.merge(fromJS({ reported: true }));
                          return comment;
                        });
                      }
                      return post;
                    });
                  });
    case (constants.REPORT_COMMENT_FAILED || constants.DELETE_COMMENT_FAILED):
      return state.set('updatingComment', false);
    case constants.LOAD_MORE_COMMENTS_STARTED:
      return state.setIn(['postComment', 'loading'], true);
    case constants.LOAD_MORE_COMMENTS_FAILED:
      return state.setIn(['postComment', 'loading'], false);
    case constants.LOADED_MORE_COMMENTS:
      if (R.pathOr(0, ['comments', 'length'], payload) < payload.numOfComments) {
        return state.setIn(['postComment', 'loading'], false)
                    .setIn(['postComment', 'hasMoreComments'], false)
                    .update('newsfeed', list => {
                      if (!list) return list;
                      return list.map(post => {
                        if (post.get('postId') === payload.postId) {
                          return post.updateIn(['body', 'comments'], comments => fromJS(comments.toJS().concat(payload.comments)));
                        }
                        return post;
                      });
                    });
      }
      return state.setIn(['postComment', 'loading'], false)
                  .update('newsfeed', list => {
                    if (!list) return list;
                    return list.map(post => {
                      if (post.get('postId') === payload.postId) {
                        return post.updateIn(['body', 'comments'], comments => fromJS(comments.toJS().concat(payload.comments)));
                      }
                      return post;
                    });
                  });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/newsfeed/reducer.js